import { render } from "./MTA2.vue?vue&type=template&id=1b46c514"
import script from "./MTA2.vue?vue&type=script&lang=js"
export * from "./MTA2.vue?vue&type=script&lang=js"

import "./MTA2.vue?vue&type=style&index=0&id=1b46c514&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__